module.exports = __webpack_public_path__ + "img/musee.5f9ab084.jpg";